// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list__koPT2x1Qid{padding:0;margin:0;list-style:none}`, "",{"version":3,"sources":["webpack://./src/assets/fable/flowEditor/components/flowManager/canvas/components/contextMenu/contextMenu.module.scss"],"names":[],"mappings":"AAAA,kBACE,SAAA,CACA,QAAA,CACA,eAAA","sourcesContent":[".list {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `list__koPT2x1Qid`
};
export default ___CSS_LOADER_EXPORT___;
